<template>
  <v-btn
    v-bind="$attrs"
    depressed
    x-large
    class="base-button"
    :ripple="false"
    :class="[
      { 'uppercase': uppercase },
      { 'hover': hover },
      { 'loading': loading },
      { 'round': round },
      'btn--'+backgroundColor
    ]"
    @click="emitClick"
    @mouseover="hover = true"
    @mouseleave="hover = false"
  >
    <div v-if="loading">
      <base-loader
        :loading="loading"
        :color="loaderColor"
        margin="0"
      />
    </div>
    <div
      v-else-if="icon && text"
      class="d-flex align-center icon-and-text"
    >
      <v-icon class="mr-2">
        {{ icon }}
      </v-icon>
      <span>{{ text }}</span>
    </div>
    <v-icon v-else-if="icon">
      {{ icon }}
    </v-icon>
    <div v-else>
      {{ text }}
    </div>
  </v-btn>
</template>

<script>
export default {
  name: 'BaseButton',
  props: {
    backgroundColor: {
      type: String,
      default: 'dark-blue'
    },
    text: {
      type: String,
      default: null
    },
    uppercase: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hover: false
    }
  },
  computed: {
    loaderColor () {
      if (this.hover && this.backgroundColor.includes('outline')) {
        return 'white'
      }
      switch (this.backgroundColor) {
      case 'none':
      case 'outline-dark-blue':
      case 'outline-grey':
      case 'off-white':
        return 'primary'
      default:
        return 'white'
      }
    }
  },
  methods: {
    emitClick ($event) {
      if (!this.loading) {
        this.$emit('click', $event)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import './src/styles/variables';

  .base-button {
    color: $white;
    font-weight: $font-weight-bold;
    transition: background-color 0.2s ease;
    height: 35px !important;
    min-height: 35px;
    text-decoration: none;
    font-size: $font-medium;

    &:not(.uppercase) {
      text-transform: none;
    }

    &.round {
      border-radius: 20px;
      padding: 0 5px !important;
    }
  }

  .btn--none {
    background-color: transparent !important;
    font-size: $font-small;
    color: $dark-blue;

    .icon-and-text {
      color: $charcoal-grey;
    }

    &:not(.v-btn--block) {
      min-width: 0;
      padding: 0 10px;
    }

    &:hover {
      background-color: $even-lighter-grey !important;
    }

    .v-icon {
      color: $dark-blue;
    }
  }

  .btn--light-grey {
    background-color: $light-grey !important;
  }

  .btn--off-white {
    @extend .base-button;
    color: $charcoal-grey;
    background-color: $off-white !important;

    &:hover, &.hover {
      background-color: #dae1d1 !important;
    }

    &:active {
      background-color: #c0c9b5 !important;
    }
  }

  .btn--grey {
    @extend .base-button;
    background-color: $grey !important;

    &:hover, &.hover {
      background-color: #5c6d7e !important;
    }

    &:active {
      background-color: #465462 !important;
    }
  }

  .btn--dark-blue {
    @extend .base-button;
    background-color: $dark-blue !important;

    &:hover, &.hover {
      background-color: #214a6f !important;
    }

    &:active {
      background-color: #143553 !important;
    }
  }

  .btn--light-green {
    @extend .base-button;
    color: $charcoal-grey !important;
    background-color: $even-lighter-green !important;
  }

  .btn--outline-dark-blue {
    @extend .base-button;
    background: none !important;
    border: 1px solid $dark-blue;
    color: $dark-blue;

    &:hover, &.hover {
      color: white;
      background-color: $dark-blue !important;
    }

    &:active {
      color: white;
      background-color: #214a6f !important;
    }
  }

  .btn--outline-grey {
    @extend .base-button;
    background: none !important;
    border: 1px solid $grey;
    color: $grey;

    &:hover, &.hover {
      color: white;
      background-color: $grey !important;
    }

    &:active {
      color: white;
      background-color: #747f8b !important;
    }
  }
</style>
